export const fmtClockTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";

// One slide per capture, plus one non-photo slide per gap window, merged in
// time order so ProctoringScreenshotsView can step through both with the
// same prev/next carousel it already uses for every other violation type.
export const buildCameraSlides = (round) => {
  const { screenshots, events } = round;
  const slides = screenshots.map((s) => ({ at: s.captured_at, url: s.url, timestamp: s.captured_at }));

  events
    .filter((e) => e.type === "gap")
    .forEach((g) => slides.push({ at: g.from, timestamp: g.from, gapMinutes: g.minutes }));

  slides.sort((a, b) => new Date(a.at) - new Date(b.at));

  events
    .filter((e) => e.type === "reconnected" && e.device_changed)
    .forEach((e) => {
      const target = slides.find((s) => s.url && new Date(s.at) >= new Date(e.at));
      if (target) target.deviceChanged = true;
    });

  return slides;
};

export const cameraTileMeta = (round) => {
  const { summary } = round;
  const captures = summary.captures ?? 0;
  const disconnections = summary.disconnections ?? 0;
  return {
    count: captures,
    countTone: disconnections === 0 ? 'text-gray-500 dark:text-gray-300' : undefined,
    hasDetail: captures > 0,
    subline:
      disconnections > 0
        ? `${disconnections} ${disconnections === 1 ? 'disconnection' : 'disconnections'}`
        : null,
  };
};
